var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackListCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 39L117 119",
    stroke: "#CCE3F9",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 79C134 109.376 109.376 134 79 134C48.6243 134 24 109.376 24 79C24 48.6243 48.6243 24 79 24C109.376 24 134 48.6243 134 79Z",
    stroke: "#CCE3F9",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138 79C138 111.585 111.585 138 79 138C46.4152 138 20 111.585 20 79C20 46.4152 46.4152 20 79 20C111.585 20 138 46.4152 138 79Z",
    stroke: "#1C86F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39L119 119",
    stroke: "#1C86F1",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 158C100.211 158 117 156.881 117 155.5C117 154.119 100.211 153 79.5 153C58.7893 153 42 154.119 42 155.5C42 156.881 58.7893 158 79.5 158Z",
    fill: "#D3DBE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.42 111.069H119.419C116.677 111.069 113.997 111.882 111.718 113.405C109.439 114.928 107.662 117.093 106.613 119.626C105.564 122.158 105.29 124.945 105.824 127.634C106.359 130.323 107.679 132.792 109.618 134.731C111.556 136.669 114.026 137.989 116.715 138.524C119.403 139.059 122.19 138.784 124.723 137.735C127.255 136.686 129.42 134.91 130.943 132.63C132.466 130.351 133.279 127.671 133.279 124.93L133.279 124.928C133.272 121.255 131.81 117.734 129.212 115.136C126.615 112.539 123.094 111.076 119.42 111.069Z",
    fill: "#1C86F1",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackListCircle);
export default __webpack_public_path__ + "static/media/BlackListCircle.0028373d5f572828a54797243f5cbaa1.svg";
export { ForwardRef as ReactComponent };